import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

console.log('🌐 API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Log todas las peticiones
api.interceptors.request.use(
  (config) => {
    console.log('📤 Request:', config.method?.toUpperCase(), config.url, config.data);
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Log todas las respuestas
api.interceptors.response.use(
  (response) => {
    console.log('📥 Response:', response.status, response.data);
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth API
export const authAPI = {
  login: (username, password) => {
    console.log('🔐 Intentando login con:', { username, password: password ? '***' : 'empty' });
    return api.post('/auth/login', { username, password })
      .then(response => {
        console.log('✅ Login exitoso:', response.data);
        return response;
      })
      .catch(error => {
        console.error('❌ Error en login:', error.response?.data || error.message);
        throw error;
      });
  },
  getCurrentUser: () => api.get('/auth/me'),
};

// Public API
export const publicAPI = {
  getBanners: () => api.get('/banners'),
  getBrands: () => api.get('/brands'),
  getProducts: (brandId, search) => {
    const params = new URLSearchParams();
    if (brandId) params.append('brand_id', brandId);
    if (search) params.append('search', search);
    return api.get(`/products?${params.toString()}`);
  },
  getHeaderImages: () => api.get('/header-images'),
  getHeroImage: () => api.get('/hero-images/active'),
  getFooterImages: () => api.get('/footer-images'),
  getInstagramReels: () => api.get('/instagram-reels'),
  getLogos: (location) => api.get(location ? `/logos?location=${location}` : '/logos'),
  getConfiguration: () => api.get('/configuration'),
  sendContactMessage: (data) => api.post('/contact', data),
};

// Admin API
export const adminAPI = {
  // Banners
  getAllBanners: () => api.get('/admin/banners'),
  createBanner: (data) => api.post('/admin/banners', data),
  updateBanner: (id, data) => api.put(`/admin/banners/${id}`, data),
  deleteBanner: (id) => api.delete(`/admin/banners/${id}`),
  
  // Brands
  getAllBrands: () => api.get('/admin/brands'),
  createBrand: (data) => api.post('/admin/brands', data),
  updateBrand: (id, data) => api.put(`/admin/brands/${id}`, data),
  deleteBrand: (id) => api.delete(`/admin/brands/${id}`),
  
  // Products
  getAllProducts: () => api.get('/admin/products'),
  createProduct: (data) => api.post('/admin/products', data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  
  // Logos
  getAllLogos: () => api.get('/admin/logos'),
  createLogo: (data) => api.post('/admin/logos', data),
  updateLogo: (id, data) => api.put(`/admin/logos/${id}`, data),
  deleteLogo: (id) => api.delete(`/admin/logos/${id}`),
  
  // Header Images
  getAllHeaderImages: () => api.get('/admin/header-images'),
  createHeaderImage: (data) => api.post('/admin/header-images', data),
  updateHeaderImage: (id, data) => api.put(`/admin/header-images/${id}`, data),
  deleteHeaderImage: (id) => api.delete(`/admin/header-images/${id}`),
  
  // Footer Images
  getAllFooterImages: () => api.get('/admin/footer-images'),
  createFooterImage: (data) => api.post('/admin/footer-images', data),
  updateFooterImage: (id, data) => api.put(`/admin/footer-images/${id}`, data),
  deleteFooterImage: (id) => api.delete(`/admin/footer-images/${id}`),

  // Hero Images
  getAllHeroImages: () => api.get('/admin/hero-images'),
  createHeroImage: (data) => api.post('/admin/hero-images', data),
  updateHeroImage: (id, data) => api.put(`/admin/hero-images/${id}`, data),
  deleteHeroImage: (id) => api.delete(`/admin/hero-images/${id}`),

  
  // Instagram Reels
  getAllInstagramReels: () => api.get('/admin/instagram-reels'),
  createInstagramReel: (data) => api.post('/admin/instagram-reels', data),
  updateInstagramReel: (id, data) => api.put(`/admin/instagram-reels/${id}`, data),
  deleteInstagramReel: (id) => api.delete(`/admin/instagram-reels/${id}`),
  
  // Users (Admin only)
  getAllUsers: () => api.get('/admin/users'),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),

  // Configuration
  getConfiguration: () => api.get('/configuration'),
  updateConfiguration: (data) => api.post('/admin/configuration', data),
  testEmailConfig: (data) => api.post('/admin/test-email', data),

  // Upload
  uploadFile: (file, onUploadProgress) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress
    });
  },
};

export default api;
